import React from 'react';

import { Typography, Section, Box } from '@gogame/components';

import AdjustedSpend from './AdjustedSpend';
import Difference from './Difference';
import ExpenseType from './ExpenseType';
import ManualSpending from './ManualSpending';

const Stats = ({
  loading,
  error,
  isSpendTypeByRegs,
  isCostAdjustment,
  stats = {},
  isEditing,
  isFRRefund = false,
}) => {
  if (loading) {
    return (
      <Section>
        <Typography>Loading Spend Adjustment Stats...</Typography>
      </Section>
    );
  }
  if (error) {
    return (
      <Section>
        <Box sx={{ color: 'error.main' }}>
          <Typography>{error}</Typography>
        </Box>
      </Section>
    );
  }

  return (
    <React.Fragment>
      {isCostAdjustment ? (
        isFRRefund ? (
          <AdjustedSpend data={stats} />
        ) : (
          <Difference data={stats} />
        )
      ) : (
        <React.Fragment>
          <ExpenseType isEditing={isEditing} />
          {isSpendTypeByRegs ? <ManualSpending data={stats} /> : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Stats;
